import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { 
	NavItem, 
	NavLink,
	Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './MenuLinks.scss';

function MenuLinks() {
	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	/* eslint-enable no-unused-vars */

	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(!dropdownOpen);

	const gerarRelatorio = () => {

	};

	return (
		<>
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>

			<NavItem>
				<NavLink 
					// onClick={gerarRelatorio} 
					// className="darkblue-border-left"
				>
					{/* <span className="menu-icon">
						<i className="fas fa-circle green" />
						Links Disponíveis
					</span> */}
					<Dropdown nav isOpen={dropdownOpen} toggle={toggle} className="dropdown">
						<DropdownToggle color="#193d5a" className="dropdown">
						<i className="fas fa-circle green" />
						Links Disponíveis
						<i className="fas fa-chevron-down chevron" />
						</DropdownToggle>
						<DropdownMenu className="list">
							<DropdownItem className="links">
								<NavItem>
									<NavLink
										href="https://auditor.econeteditora.com.br/validar-login"
										className="itemList-first"
										target="_blank"
									>
										<i className="fas fa-external-link-alt external-link" />
										Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
									</NavLink>
									<NavLink
										href="https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_DisponibilidadeUF.jsp"
										className="itemList"
										target="_blank"
									>
										<i className="fas fa-external-link-alt external-link" />
										Verificar disponibilidade de emissão por UF
									</NavLink>
									<NavLink
										href="https://www.gnre.pe.gov.br:444/gnre/portal/bancosArrecadadores.jsp"
										className="itemList-last"
										target="_blank"
									>
										<i className="fas fa-external-link-alt external-link" />
										Verificar disponibilidade de remessa bancária por UF
									</NavLink>
								</NavItem>
							</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</NavLink>
			</NavItem>
		</>
	);
}

export default withRouter(MenuLinks);
